import { render, staticRenderFns } from "./notas_fornecedor.vue?vue&type=template&id=a94197b8"
import script from "./notas_fornecedor.vue?vue&type=script&lang=js"
export * from "./notas_fornecedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports